module.exports = __webpack_public_path__ + "static/media/TimeAfterTime_jacket.355904ba.jpg";